export const initialState = () => ({
  cep: "",
  address: "",
  number: "",
  noNumber: false,
  neighborhood: "",
  state: "",
  city: "",
  complements: [""],
  noComplement: false,
  addressNote: ""
})
